import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {UserDetailsModel} from '../../../../constants/userModel';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../../services/api.service';
import {ErrorService} from '../../../../shared/error-page/service/error-service';
import {Constants} from '../../../../constants/ebtq-constants';
import {EBTransactionAbstract} from '../../../../model/eBTransactionAbstract';
import {TransactionWrapper} from '../../../../model/transactionWrapper';
import {Router} from '@angular/router';
import {UtilityService} from '../../../../services/utility-service';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-loanpayoff',
  templateUrl: './loanpayoff.component.html',
  styleUrls: ['./loanpayoff.component.scss']
})
export class LoanpayoffComponent implements OnInit {
  successMess: boolean;
  loanNumber: string;
  effDate: string;
  containsError = false;
  errorMsg: string;
  payoffAmount: string;
  showErrorDiv = false;
  errHeading: string;
  errorMessage: any[];
  userDetails: UserDetailsModel;
  transAmount: number;
  mainPage: string;
  actionCode: any[];
  actionCodeType: string;
  utilService: UtilityService;
  displayWarningMsg: any[];
  title = 'Loan Payoff';
  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private router: Router, private routerCore: Router, private titleService: Title, private cdr: ChangeDetectorRef) {

    this.mainPage = 'transactions';
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.utilService = new UtilityService();
    this.successMess = false;
    this.errHeading = Constants.ERROR_HEADER;
    this.errorMessage = [];
    this.userDetails = Constants.USER_DETAILS;
    this.actionCode = [];
    this.actionCode.push({label: '65-Repurchased', value: '65'});
    this.actionCode.push({label: '66-Refinanced', value: '66'});
    this.actionCode.push({label: '31-Payoff/Death', value: '31'});
    this.actionCode.push({label: '32-Payoff/Borrower_moved', value: '32'});
    this.actionCode.push({label: '33-Payoff/Borrower_Paid_Off', value: '33'});
    this.actionCode.push({label: '34-Payoff/Other_Reason', value: '34'});
    this.actionCode.push({label: '35-Payoff/Unknown_Reason', value: '35'});
    this.actionCodeType = '65';


  }

  clearBtn() {
    this.successMess = false;
    this.effDate = '';
    this.loanNumber = '';
    this.transAmount = null;
  }

  loanpayoffComponent() {
    this.errorMessage = [];
    if (this.validate()) {
      const ebTransactionAbstract = new EBTransactionAbstract();
      ebTransactionAbstract.effectiveDate = this.effDate;
      ebTransactionAbstract.lastUpdatedUserId = sessionStorage.getItem('userID');
      ebTransactionAbstract.fannieMaeLoanNumber = this.loanNumber;
      ebTransactionAbstract.appCode = this.actionCodeType;
      ebTransactionAbstract.transactionAmount = this.transAmount;
      ebTransactionAbstract.recordCreatorUserID = sessionStorage.getItem('userID');
      this.getServiceNumber(ebTransactionAbstract);
    }
  }

  /** Navigate to Loan detailed page */
  public loanDetail() {
    if (this.loanValidate()) {
      const transactionWrapper = new TransactionWrapper();
      transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
      transactionWrapper.parameters[0] = this.loanNumber;
      transactionWrapper.effDate = this.effDate;
      transactionWrapper.appCode = this.actionCodeType;
      this.apiService.executeQuery(transactionWrapper)
        .subscribe(
          (data: any) => {
            if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
              this.errorMessage.push(Constants.LOAN_NOT_ACTIV);
            } else {
              const srvrNo = data.object[0].SRVR_NO;
              if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
                this.errorMessage.push(Constants.USR_NOT_AUTH + srvrNo);
              } else {
                this.router.navigate(['queryLoansDetails'], {
                  queryParams: {
                    loanNumber: this.loanNumber,
                    mainPage: this.mainPage,
                    subPage:'loanPayOff'
                  }
                });
              }
            }
            this.cdr.detectChanges();
          });
    }
  }

  loanValidate() {
    this.errorMessage = [];
    this.successMess = false;
    let valid = true;
    if (this.loanNumber === undefined || this.loanNumber === '' || this.loanNumber.length !== 10 || !/^[0-9]+$/.test(this.loanNumber) || !this.loanNumber.startsWith('6')) {
      valid = false;
      this.errorMessage.push(Constants.LOAN_NUM_ERR_COUNT);
    }
    return valid;
  }


  dateToStringConversion()
  {
    const date = this.utilService.convertDateToMillisec(this.effDate);
    return this.utilService.convertMillisecToDate(date);

  }


  validate() {
    this.errorMessage = [];
    this.successMess = false;
    let valid = true;
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if (this.effDate != null && this.effDate !== undefined) {
      const dateString = this.dateToStringConversion();
      this.effDate = dateString;
      console.log('date string', dateString);
    }
    this.loanValidate();
    if (this.effDate === undefined || this.effDate === '' || this.effDate == null) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_EMPTY);
    } else if (!this.validateDateFormat(this.effDate)) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_ERR_FORMAT);
    } else if (!this.isValidDate(this.effDate)) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_ERR_FORMAT);
    } else if (!this.isValidDateYear(this.effDate)) {
      valid = false;
    }

    // @ts-ignore
    if (this.transAmount === undefined  || this.transAmount === null || this.transAmount === '') {
      valid = false;
      this.errorMessage.push(Constants.LOAN_AMT_EMPTY_MESSAGE);
    } else if (this.transAmount < 0 || this.transAmount === 0) {
      valid = false;
      this.errorMessage.push(Constants.GREATER_HTAN_ZERO);
    } else {
      const transSplitLen = this.transAmount.toString().split('.');
      if (transSplitLen.length > 1) {
        const decimalDigitsLength  = transSplitLen[1].length;
        if (decimalDigitsLength > 2) {
          valid = false;
          this.errorMessage.push(Constants.LOAN_AMT_EMPTY_MESSAGE);
        } else if ( !this.transAmount.toString().match(rgx)) {
          valid = false;
          this.errorMessage.push(Constants.LOAN_AMT_EMPTY_MESSAGE);
        }
      }
    }
    return valid;
  }

  validateDateFormat(dateStr: string) {
    if (dateStr === undefined || dateStr.trim() === '' || dateStr.length !== 10) {
      return false;
    }
    return true;
  }

  isValidDate(dateString: string) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    }

    // Parse the date parts to integers
    const parts = dateString.split('/');
    const day = parseInt(parts[1], 10);
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[2], 10);

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }
    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  }


  isValidDateYear(dateString: string) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
    {return false;}
    // Parse the date parts to integers
    const parts = dateString.split('/');
    const year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1600) {
      this.errorMessage.push(Constants.PLS_RE_SUBMIT);
      return false;
    }
    return true;
  }

  showloanDetailWrappers() {
    if (this.loanValidate()) {
      const transactionWrapper = new TransactionWrapper();
      transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
      transactionWrapper.parameters[0] = this.loanNumber;
      transactionWrapper.effDate = this.effDate;
      transactionWrapper.appCode = this.actionCodeType;
      this.apiService.executeQuery(transactionWrapper)
        .subscribe(
          (data: any) => {
            if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
              this.errorMessage.push(Constants.LOAN_NOT_ACTIV);
            } else {
              const srvrNo = data.object[0].SRVR_NO;
              if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
                this.errorMessage.push(Constants.USR_NOT_AUTH + srvrNo);
              } else {
                this.routerCore.navigate(['queryTransactions'], {
                  queryParams: {
                    loanNumber: this.loanNumber,
                    mainPage: this.mainPage,
                    fromPerformTrans: true,
                    subPage:'loanPayOff'
                  }
                });
              }
            }
          });
    }
  }

  getServiceNumber(ebTransactionAbstract: EBTransactionAbstract) {
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
    transactionWrapper.parameters[0] = this.loanNumber;
    transactionWrapper.effDate = this.effDate;
    transactionWrapper.appCode = this.actionCodeType;
    //this.apiService.getServiceNumber(transactionWrapper)
    this.apiService.executeQuery(transactionWrapper)
      .subscribe(
        (data: any) => {
          if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
            this.errorMessage.push(Constants.LOAN_NOT_ACTIV);
          } else {
            const srvrNo = data.object[0].SRVR_NO;
            if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
              this.errorMessage.push(Constants.USR_NOT_AUTH + srvrNo);
            } else {
              ebTransactionAbstract.servicerNumber = '' + data.object[0].SRVR_NO;
              this.executePayoffTransaction(ebTransactionAbstract);
            }
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  executePayoffTransaction(ebTransactionAbstract: EBTransactionAbstract) {
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.parameters[0] = ebTransactionAbstract;
    this.apiService.executePayoffTransaction(transactionWrapper)
      .subscribe(
        (data: any) => {
          if (data.validationContext.errorMessages) {
            this.errorMessage = data.validationContext.errorMessages;
          } else {
            this.successMess = true;
            this.displayWarningMsg = data.validationContext.warningMessages;
          }
          this.cdr.detectChanges();
        },
        error => {
          console.log(error);
          if (error.includes('ErrorCode:500,Something bad happened; please try again later.')) {
            this.errorService.announceError(error);
          } else if (error.length > 0) {
            this.errorMessage = error;
            this.cdr.detectChanges();
          } else {
            this.errorService.announceError(error);
          }
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  // Method for on key enter submit
  trackKeyPress(e) {
    console.log('KEY CODE  ', e.keyCode);
    if (e.keyCode === 13)
    {this.loanpayoffComponent();}
  }

}
